// Местная дата «сегодня» (YYYY-MM-DD), которая сама меняется в полночь и при возврате вкладки (HQ-1821):
// Mini App часами живёт свёрнутым, а «Матчи» и «Избранное» считают дни от неё.
// Снимок — строка даты: стабилен между чтениями. В node и renderToString подписки нет (нет document).
import { useSyncExternalStore } from 'react';

/** Местная дата устройства «YYYY-MM-DD». */
export function localDate(now: Date = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

/** Полночь местного дня «YYYY-MM-DD» — для функций, которым нужен Date «сейчас» (считают только по дате). */
export function dateOfDay(day: string): Date {
  return new Date(+day.slice(0, 4), +day.slice(5, 7) - 1, +day.slice(8, 10));
}

/** Сколько мс до следующей местной полуночи (+1 с запаса на неточность таймера). */
export function msToMidnight(now: Date = new Date()): number {
  const next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  return next.getTime() - now.getTime() + 1000;
}

const listeners = new Set<() => void>();
let last = '';
let timer: ReturnType<typeof setTimeout> | undefined;

/** Будит подписчиков, только если дата правда сменилась; таймер — заново до следующей полуночи. */
function check(): void {
  const today = localDate();
  if (today !== last) { last = today; listeners.forEach((l) => l()); }
  arm();
}

function arm(): void {
  clearTimeout(timer);
  timer = listeners.size ? setTimeout(check, msToMidnight()) : undefined;
}

function onVisibility(): void {
  if (document.visibilityState === 'visible') check();
}

/** Подписка на смену местной даты: полночь и возврат вкладки. Без document — пустая. */
export function subscribeLocalToday(listener: () => void): () => void {
  if (typeof document === 'undefined') return () => {};
  if (!listeners.size) {
    last = localDate();
    document.addEventListener('visibilitychange', onVisibility);
  }
  listeners.add(listener);
  arm();
  return () => {
    listeners.delete(listener);
    if (!listeners.size) { document.removeEventListener('visibilitychange', onVisibility); arm(); }
  };
}

const snapshot = () => localDate();

/** «Сегодня» по часам устройства; компонент перерисуется в полночь и при возврате вкладки, если дата сменилась. */
export function useLocalToday(): string {
  return useSyncExternalStore(subscribeLocalToday, snapshot, snapshot);
}
